import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { VisibilityOutlined } from '@mui/icons-material';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { AuthContext } from '../../../contexts/AuthContext';
import { ModalsContext } from '../../../contexts/ModalsContext';
import { encontrarModulo } from '../../../helpers/encontrarModulo';
import { ReadResponseForm } from './ReadResponseForm';
import { useModalStore } from '../../../store/useModalStore';

export const Actions = ({ data }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    // const { modalRef: { current: { handleOpen } } } = useContext(ModalsContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'respuestas')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    // const openModal = (form) => handleOpen(form);

    const buttons = [
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => openModal(<ReadResponseForm data={ data } />) },
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}